<template>
  <Loader :loader="loader" />
  <div class="w-full" v-if="!loader">
    <div
      class="w-full bg-h-primary-100 shadow-sm z-10 select-none h-16 flex items-center"
    >
      <div class="container px-5 sm:px-0">
        <p>
          {{
            $t("labels.generic", {
              pt: "Certificado de conclusão",
              en: "Certificate of completion",
            })
          }}
        </p>
      </div>
    </div>
    <div class="w-full container mx-auto mt-8 flex flex-col gap-4 items-center text-center sm:flex-row sm:justify-between sm:items-center sm:text-start">
      <div>
        <h3>
          {{ $t("labels.generic", { pt: "Certificado", en: "Certificate" }) }}
        </h3>
      </div>
      <div class="flex flex-col sm:flex-row gap-3 w-full px-5 sm:px-0 sm:w-auto">
        <Button
          class="btn-outline-bg-white h-12 sm:h-10 w-full sm:w-auto flex justify-center sm:justify-start items-center"
          @click="printPdf"
        >
          {{ $t("labels.generic", { pt: "Imprimir", en: "Print out" }) }}
        </Button>

        <Button
          class="btn-primary h-12 sm:h-10 w-full sm:w-auto flex justify-center sm:justify-start items-center"
          @click="downloadPDF"
        >   
          {{
            $t("labels.generic", {
              pt: "Baixar o certificado",
              en: "Download certificate",
            })
          }}
        </Button>
      </div>
    </div>
    <div v-if="url" class="container mx-auto mt-8 h-screen">
      <iframe
        ref="pdfViewer"
        :src="url"
        frameborder="0"
        class="w-full h-[70%] lg:h-[90%]"
      ></iframe>
    </div>
  </div>
</template>

<script lang="ts">
import { getUserFromStorage } from "@/utils/user-store.util";
import { defineComponent } from "vue";
import { CourseStudentService } from "../../course-student.service";

export default defineComponent({
  name: "courseCertificate",
  components: {},
  data() {
    return {
      url: "" as string,
      loader: true as boolean,
    };
  },
  computed: {
    service(): CourseStudentService {
      return new CourseStudentService();
    },
    user(): any {
      return getUserFromStorage();
    },
    classroomID(): string | undefined {
      return localStorage.getItem("classId") ?? undefined;
    },
  },
  props: {
    userId: String,
    courseId: String,
  },
  mounted() {
    this.getCertificate();
  },
  methods: {
    getCertificate(): void {
      this.service.certificate.subscribe((response) => {
        const blob = new Blob([response], { type: "application/pdf" });
        const url = URL.createObjectURL(blob);
        this.url = url;
        this.loader = false;
      });
      this.service.getCourseCertificate(
        this.courseId ?? "",
        this.userId ?? "",
        this.classroomID
      );
    },
    printPdf(): void {
      const iframe: any = this.$refs.pdfViewer;
      iframe.contentWindow.print();
    },
    downloadPDF(): void {
      const link = document.createElement("a");
      link.href = this.url;
      link.download = this.$t("labels.generic", {
        pt: "meu-certificado.pdf",
        en: "my-certificate.pdf",
      });
      link.click();
    },
  },
});
</script>
